import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/landing";
type FloatingCtaProps = {
  anchorId: string;
};
export function FloatingCta({
  anchorId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = document.getElementById(anchorId);
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [anchorId]);
  return <AnimatePresence data-id="element-32" data-mp="19787o99nwlgd">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-33" data-mp="1989kai6btg07">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl bg-cta px-4 py-4 text-base font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-8px_rgba(22,163,74,0.7)] ring-2 ring-white transition-colors duration-150 ease-out hover:bg-ctadark" data-id="element-34" data-mp="2f3940zkn4xzd">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" strokeWidth={2.5} aria-hidden="true" data-id="element-35" data-mp="1wecaixx2i9i7" />
            <span data-id="element-36" data-mp="1if36ewm4z5ul">Get It Now · Only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}